import Vue from 'vue';

    import zhCN from 'date-format-parse/lib/locale/zh-cn';

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

const lang = {
  formatLocale: zhCN,
  yearFormat: $t('db30fe19588fd8c4'),
  monthFormat: $t('8629fc47adf62a40'),
  monthBeforeYear: false,
};

export default lang;
